import { useBreakPoints } from 'core';
import { useNavigate } from 'react-router-dom';
import { ButtonMantine, Group, Stack, Title } from 'ui';

import { MyFavoriteCausesCarousel } from './MyFavoriteCausesCarousel';

const MyFavoriteCauses = () => {
  const { isSmallScreen } = useBreakPoints();
  const navigate = useNavigate();
  return (
    <Stack gap={isSmallScreen ? 'md' : 'lg'}>
      <Group justify="space-between" wrap="nowrap">
        <Title order={2}>My Organizations</Title>
        <ButtonMantine
          variant="subtle"
          size={isSmallScreen ? 'xs' : 'sm'}
          onClick={() => navigate('/causes')}
        >
          Follow More
        </ButtonMantine>
      </Group>
      <MyFavoriteCausesCarousel />
    </Stack>
  );
};

export { MyFavoriteCauses };
